import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { upperFirst } from 'es-toolkit/compat';
import { PrimeNgStepOption } from 'ngx-ui-tour-primeng/lib/step-option.interface';

@Injectable({
  providedIn: 'root',
})
export class TourDefaultSettingsService {
  translateService = inject(TranslateService);

  getSettings(): PrimeNgStepOption {
    return {
      enableBackdrop: true,
      backdropConfig: {
        offset: 5,
      },
      centerAnchorOnScroll: true,
      smoothScroll: true,
      nextBtnTitle: upperFirst(this.translateService.instant('forward')),
      prevBtnTitle: upperFirst(this.translateService.instant('back')),
      endBtnTitle: upperFirst(this.translateService.instant('end')),
      popoverClass: 'custom-modal-ui-tour',
      disablePageScrolling: false,
      closeOnOutsideClick: false,
      allowUserInitiatedNavigation: true,
      delayBeforeStepShow: 100,
      disableScrollToAnchor: true,
      isAsync: true,
    };
  }
}
